import React, { useState, FC, useEffect } from "react";

import { Props, WeatherData, defaultData } from "./types";

const Weather: FC<Props> = ({ data = defaultData }) => {
  useEffect(() => {
    getWeatherData();
  }, [data]);

  const [weatherData, setWeatherData] = useState<WeatherData>();

  const getWeatherData = () => {
    const url = `https://api.openweathermap.org/data/2.5/weather?id=${data.city}&appid=${WEATHER_API_KEY}&units=metric&lang=zh_cn`;

    fetch(url)
      .then(response => response.json())
      .then(weatherData => {
        setWeatherData(weatherData);
      })
      .catch(error => console.error('获取天气失败:', error));
  }

  return (
  <div style={{ display: data.city && weatherData ? 'block' : 'none' }}>
    {weatherData ? <div>
      {
        weatherData.weather && weatherData.weather.length > 0 ? 
        <div style={{ position: 'relative' }}>
          <img style={{ width: '40px', height: '40px' }} src={`https://openweathermap.org/img/wn/${weatherData.weather[0].icon}@2x.png`} />
          <div style={{ display: 'inline-block', position: 'absolute', bottom: '8px' }}>{Math.round(weatherData.main.temp)}°</div>
        </div> : null
      }
      <div style={{ marginTop: '-8px' }}>{weatherData.name}</div>
    </div> : null }
  </div>
);
}
export default Weather;
